export default {
  BASE_URL: '/admin/crm/change',
  api: [
    {
      name: 'list',
      desc: '列表查询',
      method: 'GET',
      path: '/audit/list'
    },
    {
      name: 'detail',
      desc: '企业信息详情',
      method: 'GET',
      path: '/audit/detail'
    },
    {
      name: 'auditCommit',
      desc: '审核操作',
      method: 'PUT',
      path: '/audit/commit'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/member/change.js